import styled from '@emotion/styled';
import { Alert } from 'react-magma-dom';
import { COLORS } from '../../constants';

export const StyledTrialAccessBanner = styled(Alert)`
  margin-bottom: 0;

  & > div {
    background-color: ${COLORS.seaBlue}!important;
    border-radius: 0;
    justify-content: center;

    & > div {
      flex-grow: unset;
      padding: 19px 0;
    }
  }
`;

export const StyledTrialAccessContent = styled.p`
  margin: 0;
  line-height: 20px;
`;

export const StyledTrialAccessMessage = styled.span`
  font-weight: 300;
`;
